import { render, staticRenderFns } from "./manage-interpretation.html?vue&type=template&id=4abba86e&scoped=true&external"
import script from "./manage-interpretation.js?vue&type=script&lang=js&external"
export * from "./manage-interpretation.js?vue&type=script&lang=js&external"
import style0 from "./manage-interpretation.scss?vue&type=style&index=0&id=4abba86e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abba86e",
  null
  
)

export default component.exports